import { useQueryClient } from '@tanstack/react-query';
import { useCallback, useState } from 'react';
import { getShowExperimental, setShowExperimental } from '../services/experimentalOverrideService';

export const useShowExperimental = () => {
    const [showExperimental, setShowExperimentalState] = useState(getShowExperimental);
    const queryClient = useQueryClient();

    const toggle = useCallback(() => {
        const next = !showExperimental;
        setShowExperimental(next);
        setShowExperimentalState(next);
        queryClient.invalidateQueries({ queryKey: ['feature-flags'] });
    }, [showExperimental, queryClient]);

    return { showExperimental, toggle };
};
